<div class="divider-bar mb-21 mt-27 mct-flex mct-row mct-justify-between mct-items-center">
  <h4 class="mb-27">{{ 'revenue.gateway-resolution-tree.page-title' | translate }}</h4>
</div>
<div class="gateway-resolution-page-body">
  <wl-gateway-resolution-selector class="gateway-resolution-page-inputs"></wl-gateway-resolution-selector>
  <wl-gateway-resolution-graph
    class="gateway-resolution-page-graph"
    [itemNum]="itemNum"
    [accountingPackageId]="accountingPackageId"
    [paymentTypeId]="paymentTypeId"
    [ccGatewayId]="ccGatewayId"
    [invoiceNum]="invoiceNum"
  ></wl-gateway-resolution-graph>
</div>
